import { forwardRef, ReactElement, Ref } from "react";
import { EditGenericWithDestinationWindowTile, EditGenericWithDestinationWindowTilePropsBase } from "./EditGenericWithDestinationWindowTile";
import { EditTileHandle } from "./EditTile";
import { AutotaskDetailsTileModel, updateAutotaskTile } from "client/Api/Workspace/workspace";

export type EditAutotaskTileProps = EditGenericWithDestinationWindowTilePropsBase<AutotaskDetailsTileModel>;

export const EditAutotaskTile = forwardRef(
	(props: EditAutotaskTileProps, ref: Ref<EditTileHandle>): ReactElement => {

		return (
			<EditGenericWithDestinationWindowTile
				{...props}
				requestHandler={updateAutotaskTile}
				ref={ref}
			/>
		);
	}
);
EditAutotaskTile.displayName = "EditAutotaskTile";
